import { Activity, ActivityAction, ActivityActions } from "../model";
import createReducer from "./createReducer";

export const activities = createReducer<Activity[]>([], {
	[ActivityActions.LOAD_AVAILABLE_ACTIVITIES](state: Activity[], action: ActivityAction) {
		return action.payload;
	},
});
